/**
 * @fileoverview PUT handler for the "/engagement/:app_group_id/library_replace_file" endpoint.
 * Uses FormData for file upload (multipart/form-data).
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdLibraryReplaceFileCacheKeys } from "./constants";
import type {
  PutEngagementAppGroupIdLibraryReplaceFileProps,
  EngagementAppGroupIdLibraryReplaceFileResult,
} from "./types";

export const putEngagementAppGroupIdLibraryReplaceFile = reactQueryMutationAdapter(
  engagementAppGroupIdLibraryReplaceFileCacheKeys,
  (
    props: PutEngagementAppGroupIdLibraryReplaceFileProps
  ): Promise<EngagementAppGroupIdLibraryReplaceFileResult> => {
    const body = new FormData();
    body.append("file", props.file);
    body.append("id", props.id);

    return fetch(
      `/engagement/${props.app_group_id}/library_replace_file`,
      "PUT",
      {},
      { body },
      { setContentType: false }
    );
  }
);
